import has from 'has';

export const skypeFlowActions = {
  requestReseller: 'requestReseller',
  unsupportedCountry: 'unsupportedCountry',
  createBillingProfile: 'createBillingProfile',
  acceptCloudAgreement: 'acceptCloudAgreement',
};

export const hybridFlowActions = {
  cloudService: 'cloudService',
  hybridOptions: 'hybridOptions',
};

export const actions = {
  login: 'login',
  status: 'status',
  error: 'error',

  ...skypeFlowActions,

  ...hybridFlowActions,
};

export function isValidSkypeFlow(action) {
  return has(skypeFlowActions, action) || action === actions.error;
}

export function isValidHybridFlow(action) {
  return has(hybridFlowActions, action) || action === actions.error;
}

export function isValidBillingProfile(action) {
  return action === actions.createBillingProfile || action === actions.error;
}
